<template>
  <el-dialog title="我需要这类客户" :visible.sync="show" center width="586px" :close-on-click-modal="false">
    <el-row>
        <el-col :span="3" style="height: 40px;line-height: 40px;">关键词</el-col>
        <el-col :span="20" class="keyword">
          <el-input v-model="word" :maxlength="30" placeholder="输入关键词"></el-input>
            <!-- <el-input v-model="item.input" v-for="(item,i) in list" :key="i" placeholder="输入关键词"></el-input>
            <el-button icon="el-icon-plus" type="text" @click="list.push({input: ''})" v-if="list.length < 5">继续添加</el-button> -->
        </el-col>
    </el-row>
    <el-row>
        <el-col :span="3">&nbsp;</el-col>
        <el-col :span="20" class="mt-5 tal" style="color: #666666;">*添加与需要客户相关的关键词，提升推荐准确度</el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取消</el-button>
        <el-button type="primary" @click="clickSearch">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: '',
  props: {

  },
  data () {
    return {
      show: false,
      word: ''
      // list: [{ input: '' }]
    }
  },
  methods: {
    clickSearch () {
      if (!this.word) {
        this.$message.warning('请输入关键词！')
        return false
      }
      this.$router.push({
        path: '/clue/list',
        query: {
          word: this.word
        }
      })
      this.show = false
    },
    changeVisible (show) {
      this.word = ''
      this.show = show
    }
  },
  mounted () {
  }
}
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
/deep/.el-dialog__header{
    padding: 32px 20px;
    border-color: #EFEFEF;
    .el-dialog__title{
        font-size: 24px;
        color: #333;
        font-weight: 500;
    }
    .el-dialog__headerbtn{
        top: 0;
        right: 0;
        width: 53px;
        height: 50px;
        background: #4C8DEB;
        .el-dialog__close{
            color: #fff;
            font-size: 28px;
            font-weight: normal;
        }
    }
}
/deep/ .el-dialog__footer{
    border: 0;
    text-align: right !important;
    padding-bottom: 30px;
}
// .keyword{
    // height: 160px;
    // border: 1px solid #DCDCDC;
    // padding: 12px;
    // .el-input{
    //     width: 130px;
    //     margin-right: 10px;
    //     margin-bottom: 10px;
    // }
    // /deep/.el-input__inner{
    //     width: 130px;
    //     height: 36px;
    //     border: 1px #D8D8D8 dashed;
    //     border-radius: 0;
    // }
// }
</style>
